<template>
  <ReleaseNotesDisplay
    type-item-class="pa-5"
    :release-notes="releaseNotes"
  />
</template>

<script>
import { SERVICES_URL } from '@/main'
import ReleaseNotesDisplay from '@/components/service/ReleaseNotesDisplay.vue'

export default {
  components: { ReleaseNotesDisplay },
  data: () => ({
    releaseNotes: {},
  }),

  computed: {
    API_URL() {
      return `${SERVICES_URL}`
    },
  },

  mounted() {
    return this.$axios
      .get(`${this.API_URL}/release_notes`)
      .then((response) => {
        this.releaseNotes = response.data
      })
      .catch((error) => {
        console.error('Error fetching Release Notes data:', error)
      })
  },
}
</script>

<style scoped>
.pa-5 {
  padding: 20px !important;
}
</style>
